/**************************************************
 * Nombre:       Catalogo_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import {theme} from "../../../Tema";

const Catalogo_Categorias = ({setCatSeleccionada}) => {
    const {sCell} = useResponsive()
    const [categorias, setCategorias] = useState([])
    const [seleccionada, setSeleccionada] = useState({})

    useEffect(() => {

        obtenerCol('categorias').then((dox) => {
            if (dox.res) {
                setCategorias(dox.data);
                setSeleccionada(dox.data[0]);
                setCatSeleccionada(dox.data[0]);
            }
        })

    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{pt: 4, pb: 16}}
                        spacing={2}
                    >

                        {categorias.map((item, index) => (

                            <Grid container size={{xs: 3, sm: 3, md: 2}} sx={{justifyContent: 'center'}}>
                                <Grid
                                    onClick={() => {
                                        setCatSeleccionada(item)
                                        setSeleccionada(item)
                                    }}
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={1}
                                >

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Avatar src={item.img} sx={{
                                            boxShadow: '0 2px 14px rgba(0, 0, 0, 0.10)',
                                            backgroundColor: '#fff',
                                            p: 1, width: sCell ? 64 : 90, height: sCell ? 64 : 90,
                                            cursor: 'pointer',
                                            border: item.nombre === seleccionada.nombre ? 2 : 0,
                                            borderStyle: 'dashed',
                                            borderColor: theme.palette.primary.main,
                                        }}/>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography sx={{fontSize: 16, fontWeight: 600}}>{item.nombre}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>


                        ))}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Catalogo_Categorias

const items = ['Comida', 'Farmacos', 'Juguetes']